module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "alert-up",
      "appear": ""
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "y-alert",
    class: [_vm.Class]
  }, [_c('y-svg', {
    attrs: {
      "type": _vm.svgClass,
      "width": 20
    }
  }), _vm._v(" "), _c('div', {
    ref: "contents",
    staticClass: "y-alert-c"
  }, [(_vm.title) ? _c('div', {
    staticClass: "y-title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "y-content",
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.close && _vm.CloseText === '') ? _c('y-svg', {
    staticClass: "y-alert-close",
    attrs: {
      "type": "x",
      "width": 14
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeOn($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.CloseText) ? _c('span', {
    staticClass: "y-alert-close",
    on: {
      "click": _vm.closeOn
    }
  }, [_vm._v(_vm._s(_vm.CloseText))]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-cdfaaf12!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/alert/alert.vue
// module id = 500
// module chunks = 27